const crossfadeDurationMs = 150;
const wrapper = "_35sw132no3f";
const toggleGroup = "_35stu0mjho";
const transitionWrapper = "_35st1we45j2";
const content = "_35sc1ntuhp5";

export { content, crossfadeDurationMs, toggleGroup, transitionWrapper, wrapper };
import "./container.facit.style.linaria.module.css";
//# sourceMappingURL=container.facit.style.js.map
